import axios from 'axios';

export const $http = axios.create();

export const getEventUri = (projectSlug, eventSlug) =>
    `${location.protocol}//${location.host}/${projectSlug}/events/${eventSlug}`;

